import React from 'react';
import CustomLocalizationProvider from 'common/CustomLocalizationProvider/CustomLocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CustomDatePickerProps } from './interfaces';

export default function CustomDatePicker({
  label,
  views,
  sx,
  value,
  slotProps = {},
  onChange,
  onClose,
  viewRenderers,
  minDate,
}: CustomDatePickerProps) {
  return (
    <CustomLocalizationProvider>
      <DatePicker
        label={label}
        views={views}
        minDate={minDate}
        sx={sx}
        value={value}
        onChange={onChange}
        onClose={onClose}
        viewRenderers={viewRenderers}
        slotProps={slotProps}
      />
    </CustomLocalizationProvider>
  );
}
